//Name: Hair Length
//CODE: HAIL
//Age: ''
//Gender: Both
const hairLengthOptions = [
  { id: '94', name: 'Short' },
  { id: '95', name: 'Ear Level' },
  { id: '96', name: 'Shoulder Length' },
  { id: '97', name: 'Long' },
  { id: '98', name: 'Very Long' },
  { id: '99', name: 'Bald' },
  { id: '100', name: 'Balding' }
]; 

export default hairLengthOptions;



// WEBPACK FOOTER //
// ./src/data/hair-lengths.js